import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import store, { persistor } from "redux/store";
import axios from "axios";

//php
import api from "api/api";

function useLogOut() {
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const history = useHistory();

	async function beforeLogOut() {
		try {
			await axios.patch(`${api}/airline/map`, { mapId: +store.getState().map.type });
		} catch (e) {
			console.error(e);
		}
	}

	async function signOut() {
		setLoading(true);
		window.dispatchEvent(new CustomEvent("logout"));
		await beforeLogOut();

		try {
			await axios.get(`${api}/auth/logout`);

			window.map = undefined;
			window.routesLayer = undefined;
			window.aircraftPopupTimeouts = [];

			persistor.pause();
			await persistor.flush();
			persistor.purge();
			console.clear();

			dispatch({ type: "LOGOUT" });
			history.push("/");
			window.location.reload(true);
		} catch (err) {
			console.error(err);
		} finally {
			setLoading(false);
		}
	}

	return { signOut, loading };
}

export { useLogOut };
